import { render, staticRenderFns } from "./availability.vue?vue&type=template&id=4e8830de"
import script from "./availability.vue?vue&type=script&lang=js"
export * from "./availability.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e8830de')) {
      api.createRecord('4e8830de', component.options)
    } else {
      api.reload('4e8830de', component.options)
    }
    module.hot.accept("./availability.vue?vue&type=template&id=4e8830de", function () {
      api.rerender('4e8830de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/mail/availability.vue"
export default component.exports